import { Outlet, useNavigate, useNavigation, useOutlet } from 'react-router-dom';
import { CLottie, PageTitle } from 'components/atoms';
import { useAppContext } from 'hooks/context';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'hooks/redux';

const ProtectedLayoutWithChildren = () => {
  console.log('ProtectedLayoutWithChildren');
  const { state, location } = useNavigation();
  const { isPageTitleVisible } = useAppSelector((state) => state.app);
  const { t } = useTranslation(['translation', 'common']);
  const navigate = useNavigate();
  const outletData = useOutlet();
  const { title, titleChildren } =
    outletData?.props?.children?.props?.children?.props?.children?.props?.children?.props ??
    outletData?.props?.children?.props?.children?.props?.children?.props ??
    outletData?.props?.children?.props?.children?.props ??
    {};

  const {
    dialog: { showDialog },
  } = useAppContext();

  // useEffect(() => {
  //   showDialog({
  //     type: 'warning',
  //     message: t('appointment.ask-pet-add'),
  //     onClose: () => null,
  //     onApprove: () => null,
  //     onApproveTitle: `${t('pet.add')}*`,
  //   });
  // }, []);

  return (
    <>
      {state === 'loading' ? (
        <CLottie isFullPage />
      ) : (
        <>
          {title && isPageTitleVisible && <PageTitle title={title}>{titleChildren ?? null}</PageTitle>}

          <Outlet />
        </>
      )}
    </>
  );
};

export default ProtectedLayoutWithChildren;
